import CancelTemplates from 'src/components/user-mobile/ticketing/CancelTemplates';
import TopFixedBarTicketing from 'src/components/user-mobile/ticketing/TopFixedBarTicekting';
import { styled } from 'styled-components';

export default function CancelPage() {
  const isTicketCancelable = false;

  return (
    <>
      <PageContainer>
        <TopFixedBarTicketing isShowCancelBtn={isTicketCancelable} />
      </PageContainer>
      <CancelTemplates />
    </>
  );
}

const PageContainer = styled.div`
  height: 52px;
`;
